/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   getFittedMainMapZoom
 */

import { getFittedZoom, isValidBounds } from '@zcode/nr-utils'
import { ON_SERVER } from '@zcode/nr/es/shared/env'
import { ZOOM_DEFAULT, ZOOM_MIN } from '../constants'

import { guessMapDimensions } from './guessMapDimensions'

interface Props {
  allowFloat?: boolean
  box: {
    minLng: number
    minLat: number
    maxLng: number
    maxLat: number
  }
  dimensions?: { height?: number | null; width?: number | null }
  minZoom?: number
  isFullWidthMap?: boolean
}

export const getFittedMainMapZoom = ({
  allowFloat,
  box,
  dimensions,
  minZoom = ZOOM_MIN,
  isFullWidthMap,
}: Props) => {
  if (!box || !isValidBounds(box) || ON_SERVER) {
    return ZOOM_DEFAULT
  }

  let { height, width } = dimensions ?? {}

  // Look up the map dimensions if they're not provided (and we're in a browser)
  if (!dimensions || !height || !width) {
    ;({ height, width } = guessMapDimensions({ width: null, height: null }, isFullWidthMap))
    if (!height || !width) {
      return ZOOM_DEFAULT
    }
  }

  const fittedZoom = getFittedZoom({
    bounds: box,
    dimensions: { height, width },
    minZoom,
    allowFloat,
  })
  // Force zoom to be ZOOM_MIN or higher
  return fittedZoom
}
